webpackJsonp([14633198248673],{

/***/ 982:
/***/ (function(module, exports) {

	module.exports = {"title":"Softwares","subtitle":"Start training on PC or mobile. Try out our new training methods, including our novel pattern based approach","button":"Create an account"}

/***/ }),

/***/ 983:
/***/ (function(module, exports) {

	module.exports = {"text1":"We provide training software both for your PC and also mobile for iOS and Android. For the best training results we recommend using both a PC and also our app.","text2":"Our goal is that you train efficiently with new methods and modern technology. Novel pattern based training method Comprehensive chess training. Personalized and adaptive!","text3":"We leverage state of the art technology with the goal to enable you to become the best possible version of yourself! Be the best chess player you can be!"}

/***/ }),

/***/ 182:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ChessHeader = __webpack_require__(60);
	
	var _ChessHeader2 = _interopRequireDefault(_ChessHeader);
	
	var _Jumbotron = __webpack_require__(32);
	
	var _Jumbotron2 = _interopRequireDefault(_Jumbotron);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    var jumbotronData = props.jumbotronData,
	        textsData = props.textsData;
	
	    var jumbotronImg = props.data.jumbotronImg.childImageSharp.sizes;
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'wrapper' },
	        _react2.default.createElement(_Jumbotron2.default, { jumbotronData: jumbotronData, image: jumbotronImg }),
	        _react2.default.createElement(
	            'h5',
	            null,
	            textsData.text1
	        ),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	            'h5',
	            null,
	            textsData.text2
	        ),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(
	            'h5',
	            null,
	            textsData.text3
	        ),
	        _react2.default.createElement('br', null),
	        _react2.default.createElement(_ChessHeader2.default, null)
	    );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 503:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _softwaresLayout = __webpack_require__(182);
	
	var _softwaresLayout2 = _interopRequireDefault(_softwaresLayout);
	
	var _reactHelmet = __webpack_require__(5);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _jumbotron = __webpack_require__(982);
	
	var _jumbotron2 = _interopRequireDefault(_jumbotron);
	
	var _texts = __webpack_require__(983);
	
	var _texts2 = _interopRequireDefault(_texts);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        'SciChess | Softwares'
	      )
	    ),
	    _react2.default.createElement(_softwaresLayout2.default, _extends({ jumbotronData: _jumbotron2.default, textsData: _texts2.default }, props))
	  );
	};
	
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-softwares-index-en-js-e004415187a4adbb9b13.js